import type { QuanLyLop } from '@/services/QuanLyLop';
import { useState } from 'react';
import { useModel } from 'umi';
import axios from 'axios';
import { ip3 } from '@/utils/constants';

export default () => {
  const [danhSach, setDanhSach] = useState<QuanLyLop.Record[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [total, setTotal] = useState<number>(0);
  const [record, setRecord] = useState<QuanLyLop.Record>({} as any);
  const [page, setPage] = useState<number>(1);
  const [limit, setLimit] = useState<number>(10);
  const [pageHocPhi, setPageHocPhi] = useState<number>(1);
  const [limitHocPhi, setLimitHocPhi] = useState<number>(10);
  const [cond, setCondition] = useState<any>({});
  const [filterInfo, setFilterInfo] = useState<any>({});
  const [visibleForm, setVisibleForm] = useState<boolean>(false);
  const [edit, setEdit] = useState<boolean>(false);

  const { initialState } = useModel('@@initialState');
  const parent = initialState?.currentUser?.role?.organizationId;
  const getThongTinHocSinhModel = async () => {
    if(cond?.donViId && cond?.donViId !== 'Tất cả') {
      const response = await axios.get(`${ip3}/con/pageable/lop/${cond?.donViId}`, {
        params: {
          page,
          limit,
          cond
        },
    });
    setLoading(true);
    setDanhSach(response?.data?.data?.result ?? []);
    setTotal(response?.data?.data?.total ?? 0);
    setLoading(false);
    } else {
      const response = await axios.get(`${ip3}/con/pageable/truong/${parent}`, {
        params: {
          page,
          limit,
          cond: {
            hoTen: cond?.hoTen,
            ...(cond?.createdAt && {createdAt: cond?.createdAt})
          }
        },
      });
      setLoading(true);
      setDanhSach(response?.data?.data?.result ?? []);
      setTotal(response?.data?.data?.total ?? 0);
      setLoading(false);
    }
    
    
  };

  return {
    danhSach,
    record,
    setRecord,
    loading,
    setLoading,
    getThongTinHocSinhModel,
    total,
    setTotal,
    page,
    limit,
    setPage,
    setLimit,
    cond,
    setCondition,
    filterInfo,
    setFilterInfo,
    setVisibleForm,
    visibleForm,
    edit,
    setEdit,
    setPageHocPhi,
    setLimitHocPhi,
    pageHocPhi,
    limitHocPhi,
  };
};
